module.exports = __webpack_public_path__ + "img/whatsapp.ed0b4f0b.svg";